<template>
    <body class="container--login">
        <!-- <img
            src="/img/01_background_img.png"
            style="height:1000px;width:100%;float:left"
        /> -->
        <div class='error_box' v-if='isActive'>
            <div class='eb'>
                <p class='error'>認証エラー</p>
                <p>登録されたメールアドレスではありません．入力し直してください！</p>
                <input type="button" value="close" class='close_btn btn-red' v-on:click="isActive=false">
            </div>
        </div>
        <div id=login>
            <img
                src="/img/04_Subit_logo_B.png"
                alt="logo_menu"
                class="logo"
                style="width: 280px;"
            />
            <div id=login_box>
                <form action="" method="post" class="two_auth" onsubmit="return false;">
                    <dl>
                        <p style="font-weight:500;">あなたの登録されたメールアドレスを入力してください．パスワードをリセットするためのリンクを発行します．</p>
                        <div class="lf_code">
                            <dt><label for="code">Email</label></dt>
                            <dd><jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus /></dd>
                            <!--input type="text" name="" v-model="form.code" placeholder="Email" id="code" required autofocus-->
                        </div>
                        <div class="lf_submit">
                            <input type="submit" value="リンクを発行" v-on:click="popuperror" id="sb" class="btn">
                        </div>
                    </dl>
                </form>
            </div>
        </div>
    </body>
</template>

<style lang="css">
    *{
        padding:0;
        margin: 0;
    }
    /* html,body{
        overflow: hidden;
    } */
    .fp{
        text-align: center;
    }
    .fp a{
        opacity: 0.5;
        color: black;
    }
    input::placeholder {
        text-align: center;
    }
    #code{
        width: 280px;
    }
    #sb{
        width: 280px;
        /* font-weight: 700; */
        margin: 15px 0;
    }
    #email {
        width: 280px;
    }
    .close_btn{
        float:right;
        margin:10px;
        width:70px;
    }
    .error_box{
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 100%;
        background: rgba(1, 1, 1, 0.3);
    }
    .eb{
        border: solid black ;
        background: #FFFBF9;
        width:350px;
        height: 160px;
        position: absolute;
        top: 5%;
        left: 50%;
        transform: translate(-50%);
    }
    .eb p{
        margin: 0;
        padding:10px;
        font-size: small;
        font-weight: 300;
    }
    .error{
        background: #D20000;
        color: white;
    }
    .active{
        display: block;
    }
    .lf_rm{
        position: relative;
    }
    .lf_submit{
        float: right;
    }
    .lf_submit input{
        background: #183E7A;
        color:white;
        border-radius: 30px;
    }
    .logo{
        display: block;
        margin: 0 auto;
    }
    .body{
        /* background: white; */
        width: 100%;
        height: 100%;
        position: relative;
    }
    #login{
        position: absolute;
        top: 50%;
        left: 25%;
        transform: translate(-50%, -50%);
        color:white;
    }
    #login_box{
        /* background: #A07ABE; */
        padding: 12px 10px 10px 10px;
        width:300px;
        height: 200px;
        /* border: solid black 1px; */
    }
</style>

<script>
    import { defineComponent } from 'vue'
    import { Head } from '@inertiajs/inertia-vue3';
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    export default defineComponent ({
        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                }),
                isActive: false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        components: {
            Head,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors
        },

        props: {
            status: String
        },
        methods: {
            popuperror(){
                let reg = /^[^@]+@[^@]+$/;
                if ( !reg.test(this.form.email) ) {
                    alert("メールアドレスの形式が正しくありません。入力し直してください");
                    return;
                }

                this.form.post(
                    this.route('custom.password.email'),
                    {
                        onSuccess: (res) => {
                            alert('入力いただいたメールアドレスに、パスワード更新用URLを送付しました。');
                            this.form.reset('email');
                            
                        },
                        onError: (e) => {
                            alert(e.email);
                        },
                    }
                );
            },
        }
    })
</script>